/*
 * Campi obbligatori (regola SUI): l'etichetta finisce con un asterisco.
 * Dove il campo ha `required` (o aria-required="true") e l'etichetta non ha gia` l'asterisco scritto, lo aggiunge questo
 * controllo, che sorveglia tutta l'app: basta mettere `required` sul campo. Il segnale sta nell'attributo `data-obbligatorio`
 * dell'etichetta (stile in _sportid-design-align.scss: `label[data-obbligatorio]::after`), quindi non tocca il testo di React.
 */

const CONTROLLI = 'input[required], select[required], textarea[required], [aria-required="true"]';

const etichettaDi = (el) => {
    if (el.id) {
        const per = document.querySelector(`label[for="${CSS.escape(el.id)}"]`);
        if (per) return per;
    }
    const avvolgente = el.closest('label');
    if (avvolgente) return avvolgente;
    // Etichetta nello stesso contenitore, prima del campo (Form.Group: label + control)
    let corrente = el;
    for (let i = 0; i < 4 && corrente?.parentElement; i += 1) {
        const padre = corrente.parentElement;
        const l = padre.querySelector(':scope > label, :scope > .form-label');
        if (l) return l;
        corrente = padre;
    }
    return null;
};

const marca = () => {
    document.querySelectorAll(CONTROLLI).forEach((el) => {
        if (el.type === 'hidden' || el.type === 'checkbox' || el.type === 'radio') return;
        const l = etichettaDi(el);
        if (!l || l.hasAttribute('data-obbligatorio')) return;
        if (/\*\s*$/.test(l.textContent || '')) return;     // asterisco gia` scritto a mano
        l.setAttribute('data-obbligatorio', '');
    });
};

let avviato = false;
export const avviaAsterischi = () => {
    if (avviato || typeof document === 'undefined') return;
    avviato = true;
    let programmato = false;
    const pianifica = () => {
        if (programmato) return;
        programmato = true;
        requestAnimationFrame(() => { programmato = false; marca(); });
    };
    new MutationObserver(pianifica).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['required', 'aria-required', 'for', 'id'] });
    pianifica();
};

export default avviaAsterischi;
